import { cn } from '@costar-ui/cosmos'
import React from 'react'

import type { CellProps } from './types'

const Cell = React.forwardRef<HTMLTableCellElement, CellProps>(
  ({ className, ...props }, ref) => (
    <td
      ref={ref}
      className={cn('csg-tw-table-cell bg-content px-4 py-1', className)}
      {...props}
    />
  )
)

Cell.displayName = 'Cell'

export default Cell
